import { IConfiguration } from '@phrospr/lib-models';
import axios from 'axios';

export const apiUrl$: Promise<string> = axios
    .get('.configuration')
    .then(response => response.data.apiUrl)
    .catch(_ => {
        console.log('unable to retrieve configuration, using default instead');
        return 'http://localhost:3000';
    });

// Headers every generated-client request carries, on top of the auth header. The object is
// shared by reference with the client configuration, so an app can add to it at any time
// (the mobile app announces its build this way, see service-versions.ts in the backend).
export const clientHeaders: Record<string, string> = {};
export function setClientHeaders(headers: Record<string, string>) {
    Object.assign(clientHeaders, headers);
}

export let configuration: IConfiguration;
export const configuration$: Promise<IConfiguration> = (async () => {
    // The generated client is imported dynamically so this eager startup module
    // doesn't pull the whole client into the initial bundle; the barrel's
    // module-scope side effects defeat tree-shaking.
    const [{ GlobalApi, setDefaultConfiguration }, basePath] = await Promise.all([
        import('@phrospr/api-backend'),
        apiUrl$,
    ]);
    // make sure it is not awaiting the access token
    setDefaultConfiguration({ basePath, baseOptions: { headers: clientHeaders } });
    configuration = (await GlobalApi.getConfiguration()).data;
    return configuration;
})();
